import React from "react";
import "./Functions.css";
import full from "./fullStack.json";
import ui from "./uiux.json";

const Functions = () => {
    return (
        <div className="functions functions-container mt-5">
            <div className="row mb-5">
                <div className="col-12 col-sm-12 col-md-12">
                    <h3 className="title">Our Functions</h3>
                </div>
            </div>

            <div className="row functionRow">

                <div className="col-12 col-sm-12 col-md-12 col-lg-6">
                    <div className="row">
                        <div
                            className="col-12 col-sm-12 col-md-12 col-lg-12 fullStack columnTitle mr-5 mb-4">
                            <h3>Full-Stack Development</h3>
                        </div>
                    </div>

                    <div className="row">
                        {full.map((element) => {
                            return (
                                <div
                                    key={element.id}
                                    className="full col-12 col-sm-12 col-md-12 col-lg-12 boxServe mr-5 mb-4"
                                    data-aos="flip-up">
                                    <div className="row">
                                        <div className="col-3 col-sm-3 col-md-3 col-lg-3">
                                            <img
                                                src={`../../../images/logos/services/logoSizes/${element.src1}`}
                                                srcSet={`../../../images/logos/services/logoSizes/${element.src2} 2x,../../../images/logos/services/logoSizes/${element.src3} 3x`}
                                                className="logos"/>
                                        </div>
                                        <div className="col-9 col-sm-9 col-md-9 col-lg-9 content">
                                            <h2 className="sectionTitle">{element.Name}</h2>
                                            <p className="sectionContent">{element.Content}</p>
                                        </div>
                                    </div>
                                </div>
                            );
                        })}

                    </div>

                </div>

                <div className="col-12 col-sm-12 col-md-12 col-lg-6">
                    <div className="row">
                        <div
                            className="col-12 col-sm-12 col-md-12 col-lg-12 uiux columnTitle mr-5 mb-4">
                            <h3>UX/UI Design</h3>
                        </div>
                    </div>

                    <div className="row">
                        {ui.map((element) => {
                            return (
                                <div
                                    key={element.id}
                                    className="ux col-12 col-sm-12 col-md-12 col-lg-12 boxServe mr-5 mb-4"
                                    data-aos="flip-up">
                                    <div className="row">
                                        <div className="col-3 col-sm-3 col-md-3 col-lg-3">
                                            <img
                                                src={`../../../images/logos/services/logoSizes/${element.src1}`}
                                                srcSet={`../../../images/logos/services/logoSizes/${element.src2} 2x,../../../images/logos/services/logoSizes/${element.src3} 3x`}
                                                className="logos"/>
                                        </div>
                                        <div className="col-9 col-sm-9 col-md-9 col-lg-9 content">
                                            <h2 className="sectionTitle">{element.Name}</h2>
                                            <p className="sectionContent">{element.Content}</p>
                                        </div>
                                    </div>
                                </div>
                            );
                        })}
                    </div>

                </div>

            </div>
        </div>
    );
};

export default Functions;



// WEBPACK FOOTER //
// ./src/components/Services/Functions/Functions.js